import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { clearAppSessionStorage } from '@commons/auth/session';
import { getSessionStorageItem, removeSessionStorageItem } from '@commons/utils/sessionStorage';
import {
  MOS_FORCE_REAUTH_STORAGE_KEY,
  MOS_ID_TOKEN_HINT_STORAGE_KEY,
  MOS_RETURN_URL_STORAGE_KEY,
  MOS_START_LOGIN_AFTER_LOGOUT_KEY,
} from '@commons/auth/constants';
import mosAuth from '@services/mosAuth';

/**
 * Registered MOS post-logout redirect target. Local session is already cleared before end-session.
 * After a 401-driven reauth, end-session lands here then restarts authorize without SSO cookies.
 */
const MosLogout = () => {
  const history = useHistory();

  useEffect(() => {
    clearAppSessionStorage();

    const shouldStartLogin = getSessionStorageItem(MOS_START_LOGIN_AFTER_LOGOUT_KEY) === '1';

    if (shouldStartLogin) {
      removeSessionStorageItem(MOS_START_LOGIN_AFTER_LOGOUT_KEY);
      // Clear before restarting authorize — otherwise startMosLogin would end-session again.
      removeSessionStorageItem(MOS_FORCE_REAUTH_STORAGE_KEY);
      removeSessionStorageItem(MOS_ID_TOKEN_HINT_STORAGE_KEY);

      const returnUrl = getSessionStorageItem(MOS_RETURN_URL_STORAGE_KEY) || '/home';

      mosAuth.startMosLogin({ returnUrl }).catch(() => {
        history.replace('/login');
      });

      return;
    }

    history.replace('/login');
  }, [history]);

  return null;
};

export default MosLogout;
